module.exports = function getResource(label, vars) {
    const resources = {
        editLinkText: 'Edit',
        subTitle: 'FREE - Standard Shipping',
        title: 'Standard',
        autoReplenTitle: 'Delivery'
    };

    return resources[label];
};
